import React from "react";
import "./styles.scss";
import { contact } from "../../texts";
import whatsapp from "../../assets/whatsapp.png";

import ReactWhatsapp from "react-whatsapp";

const Contact = () => {
  return (
    <section id="contact">
      <div className="contactContainer">
        <div className="infoColumn">
          <div>
            <div className="subheader">Contact</div>
            <div className="subheaderBigger">Targu Mures</div>
          </div>
          <div className="infoContainer">
            <div>
              {Object.values(contact.info).map((info, index) => {
                return (
                  <div className="address" key={index}>
                    {info}
                  </div>
                );
              })}
            </div>
            <div className="hoursContainerDesktop">
              {Object.values(contact.hoursMobile).map((day, index) => {
                return (
                  <div className="day" key={index}>
                    {day}
                  </div>
                );
              })}
            </div>
            <div className="hoursContainerMobile">
              {Object.values(contact.hoursMobile).map((day, index) => {
                return (
                  <div className="day" key={index}>
                    {day}
                  </div>
                );
              })}
            </div>
          </div>
          <ReactWhatsapp
            number="+40727082781"
            message="Buna ziua!"
            className="wappDesktop"
          >
            <img
              alt="whatsapp"
              src={whatsapp}
              style={{ width: "25px", height: "25px" }}
            />
            <span style={{ marginTop: "5px", marginLeft: "5px" }}>
              Contacteaza-ne pe WhatsApp
            </span>
          </ReactWhatsapp>
        </div>
        <ReactWhatsapp
          number="+40727082781"
          message="Buna ziua!"
          className="wappMobile"
        >
          <img
            src={whatsapp}
            alt="whatsapp"
            style={{ width: "25px", height: "25px" }}
          />
          <span style={{ marginTop: "5px", marginLeft: "5px" }}>
            Contacteaza-ne pe WhatsApp
          </span>
        </ReactWhatsapp>

        <div className="map" />
      </div>
    </section>
  );
};

export default Contact;
